/**
 * Builds an external URL with dynamic query parameters
 * @param baseUrl - The base URL from environment config
 * @param dealerId - The dealer reference ID
 * @param userRefId - The user GUID
 * @returns The complete URL with appended parameters
 */
export function buildExternalUrl(
  baseUrl: string,
  dealerId: string | number | undefined,
  userRefId: string | undefined
): string {
  if (!baseUrl) {
    return '';
  }

  // Trailing slash so S3's redirect doesn't drop the query string; skipped for
  // hash-router links (e.g. VDP Connect), where it would alter the route instead.
  const normalizedBase = baseUrl.includes('#') || baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

  if (!dealerId || !userRefId) {
    return normalizedBase;
  }

  const params = new URLSearchParams({
    dealerId: String(dealerId),
    userRefId: String(userRefId),
  });

  const separator = normalizedBase.includes('?') ? '&' : '?';
  return `${normalizedBase}${separator}${params.toString()}`;
}
